import { register } from "@adobe/uix-guest";

import { handleTenantChange } from "./button-handler";
import { extensionId } from "./constants";
import { getPossibleTenants, getPreviewDataAccessLevel } from "./tenant-list";
import type { ExtensionApi } from "./types";

const init = async () => {
  console.log("Loading UE Extension");
  const previewAccess = getPreviewDataAccessLevel(window.location.href);
  const guestConnection = await register({
    id: extensionId,
    methods: {
      headerMenu: {
        getButtons() {
          return [
            ...(previewAccess !== null
              ? [
                  {
                    id: "falcon.ue-extension.onegraph.env",
                    label: "Change",
                    icon: "DataSettings",
                    variant: "action",
                    subItems: getPossibleTenants(previewAccess).map(
                      (singleTenant) => ({
                        id: singleTenant.tenant,
                        label: singleTenant.label,
                        onClick() {
                          handleTenantChange(
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            guestConnection as any,
                            singleTenant.tenant
                          );
                        },
                      })
                    ),
                  },
                ]
              : []),
          ];
        },
      },
    } as ExtensionApi,
  });
};

init().catch(console.error);
